export const useSettingsPageLoadingGate = (_routeKey: string, ready: boolean): boolean => !ready;
